import { Component, OnInit } from '@angular/core';
import { NewsService } from '../services/news.service';
import { Router } from '@angular/router';

@Component({
  selector: 'latest-news',
  templateUrl: './latest-news.component.html',
  styleUrls: ['./latest-news.component.css']
})
export class LatestNewsComponent implements OnInit {

  news ;
  constructor(private newsData:NewsService , private _router:Router) 
  { 
    this.news = this.newsData.newsData ;
    
  }

  ngOnInit() {
  }
  changeURL(tag)
  {
    
    this._router.navigate(["News/Tag",tag])
  }
  changeWritter(author)
  {
    this._router.navigate(["News/Writter",author])
  }
}
